import React, {useState, useEffect, Fragment} from 'react';
import {connect} from 'react-redux';
import Layout from '~/Components/Layout/Layout';
import InvitationStatus from '~/Components/InvitationStatus/InvitationStatus';
import PersonalDetailsForm from '~/Components/Forms/PersonalDetailsForm/PersonalDetailsForm';

import './confirm.scss';
import {Form} from "react-bootstrap";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import {Link, Redirect} from "react-router-dom";
import {confirmInvitationAction} from "~/redux/actions/invitation";
import ValidationError from "~/Components/Forms/ValidationError";
import Translate from "~/Components/ContentTranslate/Translate";
import TextTranslate, { TextTranslateString } from '../../Components/TextTranslate/TextTranslate';

const RsvpConfirm = (props) => {

    const [error, setError] = useState(null);
    const [agree, setAgree] = useState(false);

    const [form, setForm] = useState({
        email: props.auth?.user?.email,
        first_name: props.auth?.user?.first_name,
        last_name: props.auth?.user?.last_name,
        phone: props.auth?.user?.phone,
    });

    if (!props.invitation) {
        return '';
    }

    if (props.invitation.registration_status === 'submitted') {
        return <Redirect to="/preview" />
    }

    const handleConfirm = () => {

        let promise = props.dispatch(confirmInvitationAction(props.invitation.id, form, agree));

        promise.then((data) => {
            setError(null);
        }).catch((error) => {
            setError(error.response?.data);
        });
    };

    if (props.invitation.rsvp_status === 'confirmed') {
        return (
            <Layout narrow colorBg cardBorder>
                <div className="container container-confirm container-confirmed p-0">
                    <div className="row">
                        <div className="col-12">
                            <h1><TextTranslate name="word-attendance-confirmed" fallback="Attendance confirmed" /></h1>
                            <p>
                                <TextTranslate name="attendance-confirmed" fallback="Great News! You have just confirmed your attendance, and secured your place at the" textOnly/> <Translate model={props.invitation.event} field="name" />. <TextTranslate name="attendance-confirmed-2" fallback="We are looking forward to welcoming you." textOnly/>
                            </p>

                            <h3>
                                <TextTranslate name="word-next-step" fallback="Next Steps"/>
                            </h3>

                            <p className="mb-0">
                                <TextTranslate name="attendance-confirmed-note" fallback={`Now that you are registered, you will need to submit the full registration form. You can start now and come back at a later time to finish if needed,
                                your progress will be saved on the system so you can pick up from where you left off.`} textOnly />
                            </p>
                        </div>
                    </div>
                    <div className="flex-gap actions">
                        <Link className="btn btn-primary" to="/registration">
                            <TextTranslate name="word-start-registration" fallback="Start Registration" textOnly/>
                        </Link>
                        <Link className="btn btn-secondary" to="/invitation">
                            <TextTranslate name="word-return-home" fallback="Return Home" textOnly/>
                        </Link>
                    </div>
                </div>
            </Layout>
        );
    }

    return (
        <Layout narrow colorBg cardBorder>
            <div className="container-confirm">
                <div className="row">
                    <div className="head col-12">
                        <h1><TextTranslate name="attendance-confirm-title" fallback="Confirm your attendance" textOnly/></h1>
                        <p>
                            <TextTranslate name="attendance-confirm-note" fallback="We are delighted you will be able to join us for the" textOnly/> <Translate model={props.invitation.event} field="name" />. <TextTranslate name="attendance-confirm-note-1" fallback="To confirm your attendance, and secure your place, please fill in the details below." textOnly/>
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <InvitationStatus selected="yes"/>
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col-12">
                        <h3>
                            <TextTranslate name="user-personal-information" fallback="Personal Information" textOnly/>
                        </h3>

                        {error?.message && (
                            <div className="alert alert-danger" role="alert">
                                {error.message}
                            </div>
                        )}

                        <PersonalDetailsForm values={form} errors={error?.errors} onChange={setForm}/>
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col-12">
                        <h3>
                            <TextTranslate name="word-terms-conditions" fallback="Terms & Conditions" textOnly/>
                        </h3>
                        <TextTranslate
                            name="attendance-confirm-terms"
                            fallback={`<p>To enable NEOM to communicate with you about your experience, it is necessary to provide NEOM with information about you, including “personal data”, which will be used to process your registration and prepare for your experience.</p><p>NEOM respects your privacy and is committed to protecting your personal data. <a href="/terms" class="link text-primary">Click here</a> for more information about how we look after your personal data when you visit our website (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you.</p>`}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Form.Check
                            className="mx-0 p-0"
                            inline
                            type="checkbox"
                            onChange={e => {
                                setAgree(!agree)
                            }}
                            checked={agree}
                            label={
                                TextTranslateString("attendance-confirm-terms-checkbox", "I agree, and consent to collection of my personal data to take part in this experience.", props.currentLanguage, props.translations)
                            }
                        />

                        <ValidationError errors={error?.errors} name="agree"/>
                    </div>
                </div>
                <div className="flex-gap actions">
                    <ConfirmedButton
                        confirmText={<TextTranslate name="modal-confirm-confirmation-msg" fallback="Are you sure you want to confirm ?" textOnly/>}
                        onClick={handleConfirm}
                        className="btn btn-primary text-cta">
                        <TextTranslate name="attendance-button-confirm-attendance" fallback="Confirm Attendance" textOnly/>
                    </ConfirmedButton>
                    <Link className="btn btn-secondary text-cta" to="/invitation">
                        <TextTranslate name="word-cancel" fallback="Cancel" textOnly />
                    </Link>
                </div>
            </div>
        </Layout>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    translations: state.translations?.translations,
    auth: state.auth,
    invitation: state.invitation.data,
});

export default connect(mapStateToProps)(RsvpConfirm);
